<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/logbook/index">Logbook</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Create Logbook Entry
      </h6>

      <div style="padding-bottom: 100px" class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
              <div>
                <h5 class="mb-1">Create Log Entry</h5>
                <p class="text-muted mb-0">
                  Save the header first, then choose one service type, fill the fields, and save each row.
                </p>
              </div>
              <button
                type="button"
                class="btn btn-outline-primary font-size_def bdr-rad mt-2 mt-md-0"
                :disabled="savingHeader"
                @click="saveVessel"
              >
                {{ savingHeader ? "Saving..." : "Save Header" }}
              </button>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="custom-label small-label">Date</label>
                  <input
                    v-model="alldata.date"
                    type="date"
                    class="form-control bdr-rad font-size_def"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group required">
                  <label class="custom-label small-label">Vessel / Activities</label>
                  <input
                    v-model="alldata.vessel"
                    type="text"
                    class="form-control bdr-rad font-size_def"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label class="custom-label small-label">Vessel Class</label>
                  <input
                    v-model="alldata.vessel_class"
                    type="text"
                    class="form-control bdr-rad font-size_def"
                  />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label class="custom-label small-label">W/F</label>
                  <input
                    v-model="alldata.wf"
                    type="text"
                    class="form-control bdr-rad font-size_def"
                  />
                </div>
              </div>
            </div>

            <div v-if="service" class="entry-card mt-4">
              <div class="entry-head">
                <h5 class="mb-1">Add Service Entry</h5>
                <p class="text-muted mb-0">
                  Select one type and save one row at a time.
                </p>
              </div>

              <div class="entry-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="custom-label small-label">Service Type</label>
                      <select v-model="detail.service_type" class="form-control bdr-rad font-size_def">
                        <option value="">Select service type</option>
                        <option v-for="option in serviceOptions" :key="option.value" :value="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="custom-label small-label">Numbers of Crew</label>
                      <input v-model="detail.num_crew" type="number" min="0" class="form-control bdr-rad font-size_def" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="custom-label small-label">Start</label>
                      <input v-model="detail.start_time" type="datetime-local" class="form-control bdr-rad font-size_def" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="custom-label small-label">End</label>
                      <input v-model="detail.end_time" type="datetime-local" class="form-control bdr-rad font-size_def" />
                    </div>
                  </div>
                </div>

                <template v-if="detail.service_type === 'other'">
                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_1')">
                      <div class="form-group">
                        <label class="custom-label small-label">Code Name</label>
                        <select v-model="detail.code_name_1" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'other-code1-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="custom-label small-label">Remarks</label>
                        <input v-model="detail.remarks" type="text" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('tm_hrs_vessel')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ tmHoursLabel }}</label>
                        <input v-model="detail.tm_hrs_vessel" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Total Duration</label>
                        <input :value="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" readonly />
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else-if="detail.service_type === 'ship_shore_check'">
                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_1')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(1) }}</label>
                        <select v-model="detail.code_name_1" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'ssc-code1-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="custom-label small-label">Remarks</label>
                        <input v-model="detail.remarks" type="text" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('tm_hrs_vessel')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ tmHoursLabel }}</label>
                        <input v-model="detail.tm_hrs_vessel" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Total Duration</label>
                        <input :value="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" readonly />
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else-if="detail.service_type === 'housekeeping'">
                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_1')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(1) }}</label>
                        <select v-model="detail.code_name_1" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'hk-code1-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="custom-label small-label">Remarks</label>
                        <input v-model="detail.remarks" type="text" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('tm_hrs_vessel')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ tmHoursLabel }}</label>
                        <input :value="detail.tm_hrs_vessel" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" readonly />
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Total Duration</label>
                        <input :value="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" readonly />
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else-if="detail.service_type === 'maintenance'">
                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_1')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(1) }}</label>
                        <select v-model="detail.code_name_1" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'maint-code1-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="custom-label small-label">Remarks</label>
                        <input v-model="detail.remarks" type="text" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('tm_hrs_vessel')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ tmHoursLabel }}</label>
                        <input v-model="detail.tm_hrs_vessel" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">Total Duration</label>
                        <input :value="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" readonly />
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_1')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(1) }}</label>
                        <select v-model="detail.code_name_1" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'generic-code1-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('dur_c1')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.dur_c1" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="custom-label small-label">Remarks</label>
                        <input v-model="detail.remarks" type="text" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_2')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(2) }}</label>
                        <select v-model="detail.code_name_2" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'generic-code2-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('dur_c2')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.dur_c2" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_3')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(3) }}</label>
                        <select v-model="detail.code_name_3" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'generic-code3-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('dur_c3')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.dur_c3" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('code_name_4')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ codeLabel(4) }}</label>
                        <select v-model="detail.code_name_4" class="form-control bdr-rad font-size_def">
                          <option value="">Select Code Name</option>
                          <option v-for="option in memberCodeOptions" :key="'generic-code4-' + option.id" :value="String(option.id)">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('dur_c4')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration</label>
                        <input v-model="detail.dur_c4" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('nos_of_con')">
                      <div class="form-group">
                        <label class="custom-label small-label">Numbers of Connection</label>
                        <input v-model="detail.nos_of_con" type="text" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('dur_bkr')">
                      <div class="form-group">
                        <label class="custom-label small-label">Duration BKR</label>
                        <input v-model="detail.dur_bkr" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>

                    <div class="col-md-3" v-if="showField('total_duration')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ totalDurationLabel }}</label>
                        <input v-model="detail.total_duration" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3" v-if="showField('tm_hrs_vessel')">
                      <div class="form-group">
                        <label class="custom-label small-label">{{ tmHoursLabel }}</label>
                        <input v-model="detail.tm_hrs_vessel" type="number" step="0.01" min="0" class="form-control bdr-rad font-size_def" />
                      </div>
                    </div>
                  </div>
                </template>

                <div class="row">
                 

                  <div class="col-md-3 d-flex align-items-end">
                    <div class="form-group w-100">
                      <button
                        type="button"
                        class="btn btn-primary w-100 font-size_def bdr-rad"
                        :disabled="savingDetails"
                        @click="saveDetail"
                      >
                        {{ savingDetails ? "Saving..." : "Save Service Entry" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="service && savedDetails.length" class="card custom_bdr_rds shadow p-2 mt-4">
              <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Saved Entries</b></h6>

                <div class="table-responsive">
                  <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                    <thead class="background_color2">
                      <tr class="custom-label2">
                        <th>#</th>
                        <th>Type</th>
                        <th>Crew</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Code Name</th>
                        <th class="text_right">Durations</th>
                       
                        <th class="text_right">Numbers of Connection</th>
                        <th class="text_right">Durations BKR</th>
                        <th class="text_right">Total Man/Hrs</th>
                        <th class="text_right">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in savedDetails" :key="row.id || index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ formatServiceType(row.service_type) }}</td>
                        <td>{{ row.num_crew || "-" }}</td>
                        <td>{{ row.start_time || "-" }}</td>
                        <td>{{ row.end_time || "-" }}</td>
                        <td >
                          <div
                            v-for="(item, itemIndex) in buildCodeDurationRows(row)"
                            :key="'code-' + index + '-' + itemIndex"
                            class="saved-entry-line"
                          >
                            {{ item.code }}
                          </div>
                        </td>
                        <td class="text_right">
                          <div
                            v-for="(item, itemIndex) in buildCodeDurationRows(row)"
                            :key="'duration-' + index + '-' + itemIndex"
                            class="saved-entry-line"
                          >
                            {{ item.duration }}
                          </div>
                        </td>
                       
                        <td class="text_right">{{ row.nos_of_con || "-" }}</td>
                        <td class="text_right">{{ row.dur_bkr || "-" }}</td>
                        <td class="text_right">{{ row.tm_hrs_vessel || "-" }}</td>
                        <td class="text_right">
                          <button type="button" class="btn btn-sm btn-primary bdr-rad font-size_def" @click="removeSavedDetail(index)">
                            Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot style="border-top: 1px black solid;">
                      <tr>
                        <td colspan="5"></td>
                        <td><b>Total</b></td>
                        <td class="text_right"><b>{{ totalSavedHours }}</b></td>
                        <td></td>
                        <td></td>
                        <td class="text_right"><b>{{ totalSavedManHours }}</b></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div v-if="!service" class="alert alert-light border mt-4 mb-0">
              Save the vessel header first to start entering service rows.
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

const SERVICE_OPTIONS = [
  { label: "Mooring", value: "mooring" },
  { label: "Connection", value: "connection" },
  { label: "Disconnect", value: "disconnect" },
  { label: "Unmooring", value: "unmooring" },
  { label: "Other", value: "other" },
  { label: "Ship Shore Check", value: "ship_shore_check" },
  { label: "Housekeeping", value: "housekeeping" },
  { label: "Maintenance", value: "maintenance" },
];

function createEmptyHeader() {
  return {
    date: "",
    vessel: "",
    vessel_class: "",
    wf: "",
  };
}

function createEmptyDetail() {
  return {
    service_type: "",
    num_crew: "",
    code_name_1: "",
    code_name_2: "",
    code_name_3: "",
    code_name_4: "",
    start_time: "",
    end_time: "",
    dur_c1: "",
    dur_c2: "",
    dur_c3: "",
    dur_c4: "",
    nos_of_con: "",
    dur_bkr: "",
    tm_hrs_vessel: "",
    total_duration: "",
    remarks: "",
  };
}

export default {
  components: {
    ContentFooter,
    TopNavbar,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      id: this.$route.query.id || null,
      service: false,
      savingHeader: false,
      savingDetails: false,
      syncingEndTime: false,
      endTimeManuallyEdited: false,
      lastAutoEndTime: "",
      alldata: createEmptyHeader(),
      detail: createEmptyDetail(),
      savedDetails: [],
      memberCodeOptions: [],
      serviceOptions: SERVICE_OPTIONS,
      serviceFieldConfig: {
        mooring: {
          code_name_1: true,
          code_name_2: true,
          code_name_3: true,
          code_name_4: true,
          dur_c1: true,
          dur_c2: true,
          dur_c3: true,
          dur_c4: true,
          nos_of_con: true,
          total_duration: true,
        },
        connection: {
          code_name_1: true,
          code_name_2: true,
          code_name_3: true,
          code_name_4: true,
          dur_c1: true,
          dur_c2: true,
          dur_c3: true,
          dur_c4: true,
          dur_bkr: true,
          total_duration: true,
        },
        disconnect: {
          code_name_1: true,
          code_name_2: true,
          code_name_3: true,
          code_name_4: true,
          dur_c1: true,
          dur_c2: true,
          dur_c3: true,
          dur_c4: true,
          total_duration: true,
        },
        unmooring: {
          code_name_1: true,
          code_name_2: true,
          code_name_3: true,
          code_name_4: true,
          dur_c1: true,
          dur_c2: true,
          dur_c3: true,
          dur_c4: true,
          total_duration: true,
        },
        other: {
          code_name_1: true,
          total_duration: true,
          tm_hrs_vessel: true,
        },
        ship_shore_check: {
          code_name_1: true,
          total_duration: true,
          tm_hrs_vessel: true,
        },
        housekeeping: {
          code_name_1: true,
          total_duration: true,
          tm_hrs_vessel: true,
        },
        maintenance: {
          code_name_1: true,
          total_duration: true,
          tm_hrs_vessel: true,
        },
      },
    };
  },

  computed: {
    selectedServiceConfig() {
      return this.serviceFieldConfig[this.detail.service_type] || {};
    },

    showCodeRowSpacer() {
      return (
        this.showField("code_name_1") &&
        this.showField("code_name_2") &&
        this.showField("code_name_3") &&
        !this.showField("code_name_4")
      );
    },

    totalDurationLabel() {
      if (
        this.detail.service_type === "other" ||
        this.detail.service_type === "ship_shore_check" ||
        this.detail.service_type === "housekeeping" ||
        this.detail.service_type === "maintenance"
      ) {
        return "Duration";
      }

        return "Total Duration";
    },

    tmHoursLabel() {
      if (this.detail.service_type === "housekeeping") {
        return "Total Man/Hrs";
      }

      return this.detail.service_type === "maintenance" ? "Total Man/Hrs" : "Total Man/Hrs Vessel";
    },

    totalSavedHours() {
      const total = this.savedDetails.reduce((sum, row) => {
        return sum + this.savedRowHoursValue(row);
      }, 0);

      return total ? total.toFixed(2).replace(/\.00$/, "") : "0";
    },

    totalSavedManHours() {
      const total = this.savedDetails.reduce((sum, row) => {
        return sum + this.parseDurationValue(row.tm_hrs_vessel);
      }, 0);

      return total ? total.toFixed(2).replace(/\.00$/, "") : "0";
    },
  },

  watch: {
    "detail.dur_c1": "updateTotalDurationFromComponents",
    "detail.dur_c2": "updateTotalDurationFromComponents",
    "detail.dur_c3": "updateTotalDurationFromComponents",
    "detail.dur_c4": "updateTotalDurationFromComponents",
    "detail.start_time"(newValue, oldValue) {
      this.handleStartTimeChange(newValue, oldValue);
    },
    "detail.end_time"(newValue, oldValue) {
      this.handleEndTimeChange(newValue, oldValue);
    },
    "detail.service_type"() {
      this.updateServiceDurationsFromTimes();
      this.updateTotalDurationFromComponents();
    },
    "alldata.vessel_class": "updateServiceDurationsFromTimes",
    "detail.num_crew": "updateServiceDurationsFromTimes",
  },

  mounted() {
    this.loadMemberCodeOptions();

    if (this.id) {
      this.alldataLoad();
    }
  },

  methods: {
    async loadMemberCodeOptions() {
      try {
        const response = await axios.get("/logbook/membercodelist", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-Type": "application/json",
          },
        });

        if (response.data.status === 200) {
          this.memberCodeOptions = response.data.data || [];
        }
      } catch (error) {
        console.error(error.response || error);
      }
    },

    handleStartTimeChange(newValue) {
      const shouldSyncEndTime =
        !this.detail.end_time ||
        (!this.endTimeManuallyEdited && (!this.lastAutoEndTime || this.detail.end_time === this.lastAutoEndTime));

      if (shouldSyncEndTime) {
        this.syncingEndTime = true;
        this.detail.end_time = newValue || "";
        this.lastAutoEndTime = this.detail.end_time;
      }

      this.updateServiceDurationsFromTimes();
    },

    handleEndTimeChange(newValue) {
      if (this.syncingEndTime) {
        this.syncingEndTime = false;
      } else if (!newValue) {
        this.endTimeManuallyEdited = false;
        this.lastAutoEndTime = "";
      } else if (newValue !== this.lastAutoEndTime) {
        this.endTimeManuallyEdited = true;
      }

      this.updateServiceDurationsFromTimes();
    },

    parseDurationValue(value) {
      if (value === "" || value === null || value === undefined) {
        return 0;
      }

      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    },

    parseVesselClassValue(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      const match = String(value).match(/\d+/);
      if (!match) {
        return null;
      }

      const parsed = parseInt(match[0], 10);
      return [1, 2, 3, 4].includes(parsed) ? parsed : null;
    },

    calculateHourDifference(startValue, endValue) {
      if (!startValue || !endValue) {
        return "";
      }

      const start = new Date(startValue);
      const end = new Date(endValue);

      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end <= start) {
        return "";
      }

      const hours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
      return hours.toFixed(2).replace(/\.00$/, "");
    },

    updateServiceDurationsFromTimes() {
      const duration = this.calculateHourDifference(this.detail.start_time, this.detail.end_time);

      if (this.detail.service_type === "other") {
        this.detail.total_duration = duration;
        const crewCount = this.parseDurationValue(this.detail.num_crew);
        const durationValue = this.parseDurationValue(duration);
        const tmHours = crewCount && durationValue ? crewCount * durationValue : 0;
        this.detail.tm_hrs_vessel = tmHours ? tmHours.toFixed(2).replace(/\.00$/, "") : "";
        return;
      }

      if (this.detail.service_type === "ship_shore_check") {
        this.detail.total_duration = duration;
        const crewCount = this.parseDurationValue(this.detail.num_crew);
        const durationValue = this.parseDurationValue(duration);
        const tmHours = crewCount && durationValue ? crewCount * durationValue : 0;
        this.detail.tm_hrs_vessel = tmHours ? tmHours.toFixed(2).replace(/\.00$/, "") : "";
        return;
      }

      if (this.detail.service_type === "housekeeping") {
        this.detail.total_duration = duration;
        const crewCount = this.parseDurationValue(this.detail.num_crew);
        const durationValue = this.parseDurationValue(duration);
        const tmHours = crewCount && durationValue ? crewCount * durationValue : 0;
        this.detail.tm_hrs_vessel = tmHours ? tmHours.toFixed(2).replace(/\.00$/, "") : "";
        return;
      }

      if (this.detail.service_type === "maintenance") {
        this.detail.total_duration = duration;
        const crewCount = this.parseDurationValue(this.detail.num_crew);
        const durationValue = this.parseDurationValue(duration);
        const tmHours = crewCount && durationValue ? crewCount * durationValue : 0;
        this.detail.tm_hrs_vessel = tmHours ? tmHours.toFixed(2).replace(/\.00$/, "") : "";
        return;
      }

      this.detail.total_duration = "";
      this.detail.tm_hrs_vessel = "";

      const vesselClass = this.parseVesselClassValue(this.alldata.vessel_class);

      this.detail.dur_c1 = "";
      this.detail.dur_c2 = "";
      this.detail.dur_c3 = "";
      this.detail.dur_c4 = "";

      if (!duration || !vesselClass) {
        return;
      }

      if (vesselClass === 1) {
        this.detail.dur_c1 = duration;
      } else if (vesselClass === 2) {
        this.detail.dur_c2 = duration;
      } else if (vesselClass === 3) {
        this.detail.dur_c3 = duration;
      } else if (vesselClass === 4) {
        this.detail.dur_c4 = duration;
      }
    },

    updateTotalDurationFromComponents() {
      if (!this.showField("total_duration")) {
        return;
      }

      if (!(this.showField("dur_c1") || this.showField("dur_c2") || this.showField("dur_c3") || this.showField("dur_c4"))) {
        return;
      }

      const total =
        this.parseDurationValue(this.detail.dur_c1) +
        this.parseDurationValue(this.detail.dur_c2) +
        this.parseDurationValue(this.detail.dur_c3) +
        this.parseDurationValue(this.detail.dur_c4);

      this.detail.total_duration = total ? total.toFixed(2).replace(/\.00$/, "") : "";
    },

    resetDetail() {
      this.detail = createEmptyDetail();
      this.syncingEndTime = false;
      this.endTimeManuallyEdited = false;
      this.lastAutoEndTime = "";
    },

    showField(fieldName) {
      return !!this.selectedServiceConfig[fieldName];
    },

    isHeaderValid() {
      return !!(this.alldata.date && this.alldata.vessel);
    },

    isDetailValid() {
      return !!this.detail.service_type;
    },

    codeLabel(position) {
      if (
        this.detail.service_type === "other" ||
        this.detail.service_type === "ship_shore_check" ||
        this.detail.service_type === "housekeeping" ||
        this.detail.service_type === "maintenance"
      ) {
        return "Code Name";
      }

      return "Code Name " + position;
    },

    formatServiceType(value) {
      const found = this.serviceOptions.find((item) => item.value === value);
      return found ? found.label : value;
    },

    resolveMemberCodeLabel(value) {
      if (!value) {
        return "-";
      }

      const normalizedValue = String(value);
      const found = this.memberCodeOptions.find(
        (item) =>
          String(item.id) === normalizedValue ||
          item.name === value ||
          item.label === value
      );
      return found ? found.label : value;
    },

    buildCodeDurationRows(row) {
      const hasComponentDuration = [row.dur_c1, row.dur_c2, row.dur_c3, row.dur_c4].some(
        (value) => value !== "" && value !== null && value !== undefined
      );

      const items = [
        { code: row.code_name_1, duration: row.dur_c1 },
        { code: row.code_name_2, duration: row.dur_c2 },
        { code: row.code_name_3, duration: row.dur_c3 },
        { code: row.code_name_4, duration: row.dur_c4 },
      ]
        .map((item, index) => ({
          code: item.code || "-",
          duration:
            item.duration ||
            (!hasComponentDuration && index === 0 && row.total_duration ? row.total_duration : ""),
        }))
        .filter((item) => item.duration !== "" && item.duration !== null && item.duration !== undefined);

      if (items.length) {
        return items.map((item) => ({
          code: this.resolveMemberCodeLabel(item.code),
          duration: item.duration || "-",
        }));
      }

      if (row.total_duration) {
        return [
          {
            code: this.resolveMemberCodeLabel(row.code_name_1),
            duration: row.total_duration || "-",
          },
        ];
      }

      return [{ code: "-", duration: "-" }];
    },

    savedRowHoursValue(row) {
      if (row.tm_hrs_vessel !== "" && row.tm_hrs_vessel !== null && row.tm_hrs_vessel !== undefined) {
        return this.parseDurationValue(row.tm_hrs_vessel);
      }

      if (row.total_duration !== "" && row.total_duration !== null && row.total_duration !== undefined) {
        return this.parseDurationValue(row.total_duration);
      }

      return 0;
    },

    async alldataLoad() {
      try {
        const response = await axios.get("/logbook/loadvessel?id=" + this.id, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-Type": "application/json",
          },
        });

        if (response.data.status === 200) {
          this.service = true;
          this.alldata = response.data.data || createEmptyHeader();
          this.savedDetails = response.data.details || [];
        }
      } catch (error) {
        console.error(error);
        alert("Error loading logbook data.");
      }
    },

    async saveVessel() {
      if (!this.isHeaderValid()) {
        alert("Date and vessel/activity are required.");
        return;
      }

      this.savingHeader = true;

      try {
        const formData = new FormData();
        formData.append("id", this.id || "");
        formData.append("select_value", JSON.stringify(this.alldata));
        formData.append("userid", JSON.stringify(this.userid));

        const response = await axios.post("/logbook/createvessel", formData, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (response.data.status === 200) {
          this.id = response.data.data.id;
          this.service = true;
          this.$router.replace("/logbook/create?id=" + this.id);
          alert("Header saved successfully.");
        } else {
          alert("Header save failed.");
        }
      } catch (error) {
        console.error(error.response || error);
        alert("An error occurred while saving the header.");
      } finally {
        this.savingHeader = false;
      }
    },

    async persistDetails() {
      const response = await axios.post(
        "/logbook/savedetails",
        {
          id: this.id,
          userid: this.userid,
          select_value: this.alldata,
          details: this.savedDetails,
        },
        {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        }
      );

      return response.data;
    },

    async saveDetail() {
      if (!this.id) {
        await this.saveVessel();
      }

      if (!this.id) {
        return;
      }

      if (!this.isDetailValid()) {
        alert("Please select a service type.");
        return;
      }

      this.savingDetails = true;

      try {
        this.savedDetails.push({ ...this.detail });
        const data = await this.persistDetails();

        if (data.status === 200) {
          this.savedDetails = data.details || [];
          this.resetDetail();
          alert("Service entry saved successfully.");
        } else {
          this.savedDetails.pop();
          alert("Service entry save failed.");
        }
      } catch (error) {
        this.savedDetails.pop();
        console.error(error.response || error);
        alert("An error occurred while saving the service entry.");
      } finally {
        this.savingDetails = false;
      }
    },

    async removeSavedDetail(index) {
      const removed = this.savedDetails.splice(index, 1)[0];
      this.savingDetails = true;

      try {
        const data = await this.persistDetails();
        if (data.status === 200) {
          this.savedDetails = data.details || [];
        } else {
          this.savedDetails.splice(index, 0, removed);
          alert("Delete failed.");
        }
      } catch (error) {
        this.savedDetails.splice(index, 0, removed);
        console.error(error.response || error);
        alert("An error occurred while deleting the service entry.");
      } finally {
        this.savingDetails = false;
      }
    },
  },
};
</script>

<style scoped>
.entry-card {
  border: 1px solid #d9e2ec;
  border-radius: 14px;
  background: #f8fafc;
}

.entry-head {
  padding: 16px 18px;
  border-bottom: 1px solid #d9e2ec;
  background: #eef4f8;
}

.entry-body {
  padding: 18px 18px 8px;
}

.small-label {
  font-size: small;
}

.saved-entry-line + .saved-entry-line {
  margin-top: 4px;
}
</style>
